import { render, staticRenderFns } from "./WidgetCaptcha.vue?vue&type=template&id=0f23e789&scoped=true"
import script from "./WidgetCaptcha.vue?vue&type=script&lang=js"
export * from "./WidgetCaptcha.vue?vue&type=script&lang=js"
import style0 from "./WidgetCaptcha.vue?vue&type=style&index=0&id=0f23e789&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f23e789",
  null
  
)

export default component.exports